<template>
    <!--<div v-if="sign_on && userstatus_info.status==='active'" class="learning">-->
    <div class="learning" style="width: 100%;">
        <div v-if="lesson_info.code === 'fail'">
            <div class="not_access_page_div">
                <!--<img class="not_access_wrap_image" src="https://static.shiyanlou.com/frontend/dist/img/9692684.png">-->
                <div v-if="lesson_info.message=='请先登录'" class="not_access_side">
                    <div class="text">
                        您尚未登录，请登录后学习
                    </div>
                    <div style="text-align: center;width: 100%;">
                        <a @click="go_login" href="javascript:;" class="back_to_home_button">
                          立即登录
                        </a>
                    </div>
                   
                </div>
                <div v-else-if="lesson_info.message=='请先购买课程'" class="not_access_side">
                    <div class="text">
                        您尚未购买该课程，请购买后学习
                    </div>
                     <div style="text-align: center;width: 100%;">
                        <a @click="go_open_course" href="javascript:;" class="back_to_home_button">
                        立即购买
                    </a>
                    </div>
                    
                </div>
                <div v-else class="not_access_side">
                    <div class="text">
                        {{lesson_info.message}}
                    </div>
                </div>
            </div>
            <!--{{lesson_info.message}}-->
            <!--<button v-if="lesson_info.message=='请先登录'" @click="go_login">go</button>-->
            <!--<button v-if="lesson_info.message=='请先购买课程'" @click="go_open_course">go</button>-->
        </div>
        <div v-else class="col-lg-9 col-md-9 col-sm-9 col-xs-12" style="float: left;">
            <Playback v-if="this.$route.name==='playback'"></Playback>
            <Player v-else></Player>
        </div>
        <!--<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">-->
        <!--<Navigation></Navigation>-->
        <!--</div>-->
        <div v-if="lesson_info.code === 'success'" class="col-lg-3 col-md-3 col-sm-3 col-xs-12"
             style="float:left;padding: 10px 15px 10px 15px; ">
            <Content></Content>
        </div>
    </div>
</template>
<script type="text/javascript">

    import Player from '@/components/learning_page/sub_components/player.vue'
    import Playback from '@/components/learning_page/sub_components/playback.vue'
    import Navigation from '@/components/learning_page/sub_components/navigation.vue'
    import Content from '@/components/learning_page/sub_components/content.vue'

    import {mapState, mapActions} from 'vuex'

    export default {
        components: {
            Player,
            Navigation,
            Content,
            Playback,
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                lesson_info: state => state.learning.lesson_info,
                userstatus_info: state => state.course.course_userstatus[0],
            })
        },
        methods: {
            ...mapActions({
                change_show_state: 'loginState/change_show_state',
                get_course_userstatus: 'course/change_course_userstatus'
            }),
            go_login() {
                this.change_show_state('on')
            },
            go_open_course() {
                let courseId = this.$route.params.id
                this.$router.push({name: 'course', params: {id: courseId}})
            }
        },
        watch: {
            lesson_info: function () {
                document.title = `${this.lesson_info.teacher.name} - ${this.lesson_info.lesson_name}`
            }
        },
        mounted: function () {
            // if (!this.sign_on){
            //     this.change_show_state('on')
            // }
            if (this.sign_on) {
                let courseId = this.$route.params.id
                this.get_course_userstatus({'course_ids': courseId})
            }
        }

    }

</script>
<style type="text/css" scoped>
    .not_access_page_div {
        padding: 30px;
        padding-top: 150px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .not_access_wrap_image {
        width: 300px;
        margin-right: 100px;
    }

    .not_access_side {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .not_access_side_404 {
        width: 150px;
    }

    .text {
        padding: 30px 0;
        color: #666;
        font-size: 20px;
        margin: 0;
    }

    .back_to_home_button {
        color: #fff;
        border-color: #66CCFF;
        background-color: #66CCFF;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .back_to_home_button:hover {
        color: #fff;
        border-color: #069a75;
        background-color: #069a75;;
    }

    .learning {
        padding-top: 15px;
        /*width:1430px;*/
        /*height:760px;*/
        /*margin:0 auto;*/
    }
</style>
